/* global G */
import { pipe } from 'lib/util'
import { modelComposition } from 'trait/composition'
import { usesGetterSetter } from 'trait/uses'
import toAddress from 'model/_shared/transformer/toAddress'
import toNullable from 'model/_shared/transformer/toNullable'

const descriptor = 'model::recipientData'

export default pipe(
  modelComposition(descriptor),
  usesGetterSetter(G.TRANSFORMER, {
    name: toNullable('name'),
    contactInfo: toNullable('contactInfo'),
    address: toAddress('address'),
  }),
)
